import { View } from 'react-native';
import { pure } from 'recompose';
import styled from 'styled-components';
// ///////////////////////////////////////////////////////
import { spacing, sizes, background, elevation, radius } from '../../../theme/system';
// ///////////////////////////////////////////////////////
const Box = styled(pure(View))`
  /* padding & margin */
  ${spacing}
  /* width & height */
  ${sizes}
  /* background color */
  ${background}
  /* elevation (android only) */
  ${elevation}
  /* border radius */
  ${radius}
`;

// Used for debugging
Box.displayName = 'Box';

export default Box;
